import {usePostFindEmail} from 'apis/handler/auth/usePostFindEmail';
import FindEmailStep1 from 'components/login/findEmail/FindEmailStep1';
import FindEmailStep2 from 'components/login/findEmail/FindEmailStep2';
import ContentModal from 'components/modal/ContentModal';
import React, {useState} from 'react';
import {removeWhitespace} from 'utils/utility';

interface FindEmailModalProps {
  onClose: () => void;
}

const FindEmailModal = ({onClose}: FindEmailModalProps) => {
  const [step, setStep] = useState(1);

  const {mutateAsync: tryFindEmail, data} = usePostFindEmail({
    onSuccess: () => {
      setStep(2);
    },
    onError: error => {
      if (error === '일치하는 유저가 없습니다.') {
        alert('No account information matches the details you provided.');
      } else {
        alert(error);
      }
    },
  });

  const onClickFindEmail = async (form: {
    firstName: string;
    lastName: string;
    birth: string;
    countryCode: string;
    phoneNumber: string;
  }) => {
    try {
      await tryFindEmail({
        body: {
          firstName: form.firstName,
          lastName: form.lastName,
          birth: form.birth,
          countryCode: removeWhitespace(form.countryCode, 'NUM'),
          phoneNumber: removeWhitespace(form.phoneNumber, 'NUM'),
        },
      });
    } catch (error) {
      console.error(error);
    }
  };

  const renderStep = () => {
    switch (step) {
      case 1:
        return <FindEmailStep1 tryFindEmail={onClickFindEmail} />;
      case 2:
        return <FindEmailStep2 data={data} />;
      default:
        return null;
    }
  };

  return (
    <ContentModal closePosition='right-[30px] top-[30px]' onClose={onClose}>
      {renderStep()}
    </ContentModal>
  );
};

export default FindEmailModal;
